export enum DisabilityState {
  LIGHT = 'Light',
  MODERATE = 'Moderate',
  NOTABLE = 'Notable',
}
